export default function StatusOverlay({ message, duration = 2000, type = 'success' }) {
  const getBgColor = () => {
    switch (type) {
      case 'warning':
        return 'bg-orange-600';
      case 'error':
        return 'bg-red-600';
      case 'success':
      default:
        return 'bg-green-600';
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes shrink {
            from {
              width: 100%;
            }
            to {
              width: 0%;
            }
          }
        `}
      </style>
      <div className={`fixed top-20 left-1/2 -translate-x-1/2 ${getBgColor()} text-white px-6 py-2 rounded-md shadow-lg z-50`}>
        <div className="relative">
          {message}
          <div 
            className="absolute bottom-0 left-0 h-1 bg-white/30 rounded-full"
            style={{
              width: '100%',
              animation: `shrink ${duration}ms linear forwards`
            }}
          />
        </div>
      </div>
    </>
  );
} 